// extracted by mini-css-extract-plugin
export default {"loading":"baseLoading_loading__oXpjP"};